export const DEFAULT_EMPTY_MESSAGE = 'No matching records found';
export const EMPTY_MESSAGE_NO_RECORDS_FOR_THIS_PERIOD = 'No records for this period';
